var r=function(r,e){return r?"Required":e?"Encouraged":""};export{r as getPromptText};
//# sourceMappingURL=getPromptText.js.map
